import { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { useRoute } from "./hooks";
import { RouteKey } from "./types";
import { ROUTE_PATHS } from "./routePaths";
import { ProviderConfigContext } from "./ProviderConfigContext";
import { isWildcard } from "./utils";

interface ProviderRouteProps {
  routeKey: RouteKey;
  children: ReactNode;
}

export function ProviderRoute({ routeKey, children }: ProviderRouteProps) {
  const allowed = useRoute(routeKey);
  const { allowedRoutes } = useContext(ProviderConfigContext);

  if (allowed) return <>{children}</>;

  // Don't assume "dashboard" is reachable — a config that omits it would
  // otherwise redirect straight back into another blocked ProviderRoute and
  // loop forever. Fall back to whatever the config actually allows first.
  const fallbackKey = isWildcard(allowedRoutes)
    ? "dashboard"
    : allowedRoutes[0];
  const fallbackPath = fallbackKey ? ROUTE_PATHS[fallbackKey] : undefined;

  if (!fallbackPath || fallbackKey === routeKey) return null;

  return <Navigate to={fallbackPath} replace />;
}
